import axios from 'axios';

// Detect subdomain from hostname (paradise.paradiseops.com → "paradise")
// Fall back to env var, then to "paradise" for the demo deployment
function detectSubdomain() {
  const host = window.location.hostname;
  const parts = host.split('.');
  if (parts.length >= 3 && parts[0] !== 'www' && parts[0] !== 'dev') {
    return parts[0];
  }
  return process.env.REACT_APP_SUBDOMAIN || 'paradise';
}

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers['x-subdomain'] = detectSubdomain();
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // Only force logout on 401 if already authenticated (session expired),
    // not on login failures where there's no token yet
    if (err.response?.status === 401 && localStorage.getItem('token')) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
